import { eventCardClicked } from './cam-context-switcher-constants';
import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import CamContextSwitcherCard from './cam-context-switcher-card';

const tagName = 'cam-context-switcher-card-list';
const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherCardList extends HTMLElement {

  static get observedAttributes() {
    return [ 'selected-organization', 'selected-costcenter' ];
  }

  constructor() {
    super();
    this.datastore = camContextSwitcherDatastore;
    this.cardCache = {};
  }

  connectedCallback() {
    this.classList.add(tagName);

    this.addEventListener(eventCardClicked, this.handleCardChange);

    this.innerHTML = template(this.dataset);
    this.container = this.querySelector('.content-wrapper');
  }

  disconnectedCallback() {
    this.removeEventListener(eventCardClicked, this.handleCardChange);
  }

  renderCamCardList(contextList) {
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }
    contextList.forEach((card) => {
      let cardElement;

      let key = `${card.context.type}_${card.context.id}`;
      if (this.cardCache[key]) {
        cardElement = this.cardCache[key];
      } else {
        cardElement = new CamContextSwitcherCard(card);
        this.cardCache[key] = cardElement;
      }

      cardElement.disabled = !this.datastore.config.enabledContexts.includes(card.context.type) &&
        !card.context.type.includes('workspace');

      this.container.appendChild(cardElement);
    });

    if (contextList.length === 0) {
      this.container.innerHTML = '<div class="no-content">No matching items found</div>';
    }
  }

  handleCardChange(e) {
    e.cancelBubble = true;
    this.datastore.changeContext(e.detail.context);
  }

}

if (!customElements.get(tagName)) {
  customElements.define(tagName, CamContextSwitcherCardList);
}



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-card-list.js